var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-6 container-medium m-auto"},[_c('img',{staticClass:"mb-10",attrs:{"alt":"MGS logo","src":require("../assets/mgs.svg")}}),_vm._v(" DASHBOARD "),_c('pre',[_vm._v(_vm._s(_vm.$store.state.user.user.email))])])}
var staticRenderFns = []

export { render, staticRenderFns }